import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import CloseIcon from "../CloseIcon/CloseIcon";
import { useTranslation } from "react-i18next";
import { StoreContext } from "../../../store/store";
import { isCNTLD, isCOMTLD, extractPreferencesPathname } from "../../../common/utils";
import { useUnibrowContext } from "../../../App";

const StyledContainer = styled.div`
    width: 100%;
    background-color: #76b900;
    padding: 5px 40px;
    font-size: 14px;
    color: black;
    display: ${(props) => `${props.show ? "flex" : "none"}`};
    justify-content: center;
    align-items: center;
    font-weight: 700;
    position: relative;
    //TODO: uncomment when global-navigation-react plugin is used
    //position: fixed;
    //top: 88px;
    height: 40px;
    z-index: 9999;
    svg {
        width: 15px;
        cursor: pointer;
    }
`;

const PIPLUnibrowContainer = styled.div`
    width: 900px;
    display: flex;
    justify-content: space-between;
    a.unibrow-link {
        color: black;
        text-decoration: underline;
        text-decoration-color: black;
        text-decoration-thickness: 2px;
        text-underline-offset: 0.3125em;
    }
`;

export const Unibrow = (props) => {
    const { showUnibrow, setShowUnibrow } = useUnibrowContext();
    const [redirectLink, setRedirectLink] = useState("");
    const [message, setMessage] = useState("");
    const { t } = useTranslation();
    const { state, dispatch } = useContext(StoreContext);

    useEffect(() => {
        const pathname = extractPreferencesPathname(location.pathname);
        if (state.geoInfo?.countryCode === "CN" && isCNTLD()) {
            setRedirectLink(`${US_LANDING_URL}${pathname}`);
            setMessage(
                t(
                    "Please login to the US site in order to manage enterprise and developer preferences."
                )
            );
        } else if (state.geoInfo?.countryCode === "CN" && isCOMTLD()) {
            setRedirectLink(`${CN_LANDING_URL}${pathname}`);
            setMessage(
                t("Please login to the China site in order to manage consumer preferences.")
            );
        }
    }, [location.pathname, state.geoInfo]);

    useEffect(() => {
        if (state.geoInfo?.countryCode === "CN") {
            setShowUnibrow(true);
        }
    }, [state.geoInfo]);

    const hideUnibrow = () => {
        setShowUnibrow(false);
    };

    return (
        <StyledContainer show={showUnibrow}>
            <PIPLUnibrowContainer>
                <a href={redirectLink} className="unibrow-link">
                    {message}
                </a>
            </PIPLUnibrowContainer>
            <CloseIcon onClick={() => hideUnibrow()} />
        </StyledContainer>
    );
};
